import { render, staticRenderFns } from "./BarSpend.vue?vue&type=template&id=43d5acd2&"
import script from "./BarSpend.vue?vue&type=script&lang=js&"
export * from "./BarSpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports